import { useSafeOptimizelyFeature } from '@chegg/optimizely-sdk'
import { setFeatureFlags } from '@src/state/featureFlags/actions'
import { DISABLE_PARTIAL_PLAG_CHECK } from '@src/state/optimizely/constants'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

export const useDisablePartialPlagCheck = () => {
  const { isEnabled, clientReady } = useSafeOptimizelyFeature(DISABLE_PARTIAL_PLAG_CHECK)
  const dispatch = useDispatch()

  useEffect(() => {
    if (clientReady) {
      dispatch(setFeatureFlags({ paritalPlagCheckDisabled: isEnabled }))
    }
  }, [isEnabled, clientReady])
}



// WEBPACK FOOTER //
// ./src/utils/hooks/usePartialPlagCheckFlag.ts